import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DigitalTicket = ({ ticket, onAddToWallet }) => {
  const generateQRCode = (ticketId) => {
    // Generate QR code URL - using placeholder service for demo
    return `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(ticketId)}&bgcolor=FFFFFF&color=000000&margin=10`;
  };

  const detectDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/iPad|iPhone|iPod/?.test(userAgent) && !window.MSStream) {
      return 'ios';
    } else if (/android/i?.test(userAgent)) {
      return 'android';
    }
    return 'web';
  };

  const handleAddToWallet = () => {
    const device = detectDevice();
    onAddToWallet(ticket?.id, device);
  };

  return (
    <div className="bg-card rounded-lg shadow-elevation-2 border border-border overflow-hidden">
      {/* Ticket Header */}
      <div className="bg-primary text-primary-foreground p-4">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="font-semibold text-lg">{ticket?.eventName}</h3>
            <p className="text-primary-foreground/80 text-sm">{ticket?.ticketType}</p>
          </div>
          <div className="text-right">
            <p className="text-sm text-primary-foreground/80">Ticket</p>
            <p className="font-mono text-sm">{ticket?.id}</p>
          </div>
        </div>
      </div>
      <div className="p-6">
        {/* Ticket Holder */}
        <div className="mb-6">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="User" size={16} className="text-muted-foreground" />
            <span className="text-sm font-medium text-foreground">Ticket Holder</span>
          </div>
          <p className="text-lg font-semibold text-foreground">{ticket?.holderName}</p>
        </div>

        {/* QR Code */}
        <div className="text-center mb-6">
          <div className="inline-block p-4 bg-white rounded-lg shadow-inner">
            <img
              src={generateQRCode(ticket?.id)}
              alt={`QR Code for ticket ${ticket?.id}`}
              className="w-48 h-48 mx-auto"
              loading="lazy"
            />
          </div>
          <p className="text-xs text-muted-foreground mt-2">
            Present this QR code at the venue entrance
          </p>
        </div>

        {/* Event Details */}
        <div className="space-y-3 mb-6">
          <div className="flex items-center space-x-3">
            <Icon name="Calendar" size={16} className="text-muted-foreground" />
            <div>
              <p className="text-sm font-medium text-foreground">{ticket?.eventDate}</p>
              <p className="text-xs text-muted-foreground">{ticket?.eventTime}</p>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <Icon name="MapPin" size={16} className="text-muted-foreground" />
            <div>
              <p className="text-sm font-medium text-foreground">{ticket?.venueName}</p>
              <p className="text-xs text-muted-foreground">{ticket?.venueAddress}</p>
            </div>
          </div>
          {ticket?.seatInfo && (
            <div className="flex items-center space-x-3">
              <Icon name="Armchair" size={16} className="text-muted-foreground" />
              <p className="text-sm font-medium text-foreground">{ticket?.seatInfo}</p>
            </div>
          )}
        </div>

        {/* Wallet Integration */}
        <div className="space-y-2">
          <Button
            variant="outline"
            onClick={handleAddToWallet}
            iconName="Wallet"
            iconPosition="left"
            className="w-full"
          >
            Add to {detectDevice() === 'ios' ? 'Apple' : detectDevice() === 'android' ? 'Google' : 'Digital'} Wallet
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DigitalTicket;